// extracted by mini-css-extract-plugin
module.exports = {"editorFontStack":"richTextEditor-module--editorFontStack--3LNIs"};